import { useState, useEffect, useRef } from 'react';
import logo from '@/assets/logo.png';

export default function Screensaver() {
  const [isActive, setIsActive] = useState(false);
  const timeoutRef = useRef(null);
  const INACTIVITY_TIME = 60000; // 1 minute in milliseconds

  useEffect(() => {
    const resetTimer = () => {
      // Clear existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Deactivate screensaver if active
      setIsActive(false);

      // Set new timeout
      timeoutRef.current = setTimeout(() => {
        setIsActive(true);
      }, INACTIVITY_TIME);
    };

    // Events that indicate user activity
    const events = [
      'mousedown',
      'mousemove',
      'keypress',
      'scroll',
      'touchstart',
      'click'
    ];

    // Add event listeners
    events.forEach(event => {
      document.addEventListener(event, resetTimer, true);
    });

    // Start initial timer
    resetTimer();

    // Cleanup
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      events.forEach(event => {
        document.removeEventListener(event, resetTimer, true);
      });
    };
  }, []);

  const handleScreenTouch = (e) => {
    e.stopPropagation();
    setIsActive(false);
  };

  if (!isActive) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[200] bg-[#1656A4] flex flex-col items-center justify-center cursor-pointer"
      onClick={handleScreenTouch}
      onTouchStart={handleScreenTouch}
      data-testid="screensaver"
    >
      <div className="flex flex-col items-center justify-center gap-8 animate-pulse">
        <img 
          src={logo} 
          alt="Dynamo Gymnastics" 
          className="w-[60vw] max-w-4xl h-auto"
          data-testid="screensaver-logo"
        />
        <div 
          className="text-white text-4xl font-bold"
          data-testid="touch-to-start"
        >
          Touch to Start
        </div>
      </div>
    </div>
  );
}
